import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SimpleAuthApp from './components/login/LoginPage';
import { RecoilRoot } from 'recoil';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RecoilRoot>
      <SimpleAuthApp />
    </RecoilRoot>
);